var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"partTable",attrs:{"pageUnit":_vm.pagingInfo.pageUnit,"totalSize":_vm.pagingInfo.totalSize,"paging":"","columns":_vm.columns,"rows":_vm.partList,"stripe":false,"selection":false,"height":"520px"},on:{"changedPage":_vm.changedPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }